import { Component } from '@theme/component';

class OrvenaBenefits extends Component {
  #index = 0;
  #timer;
  #events;
  #motion;
  #paused = false;

  connectedCallback() {
    super.connectedCallback();
    this.#events = new AbortController();
    this.#motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.#paused = this.#motion.matches;
    const options = { signal: this.#events.signal };
    this.addEventListener('mouseenter', () => this.#stop(), options);
    this.addEventListener('mouseleave', () => this.#start(), options);
    this.addEventListener('focusin', () => this.#stop(), options);
    this.addEventListener('focusout', () => queueMicrotask(() => this.#start()), options);
    document.addEventListener('visibilitychange', () => this.#start(), options);
    this.#motion.addEventListener('change', () => {
      this.#paused = this.#motion.matches;
      this.#syncToggle();
      this.#start();
    }, options);
    this.#show();
    this.#syncToggle();
    this.#start();
  }

  disconnectedCallback() {
    this.#stop();
    this.#events?.abort();
    super.disconnectedCallback();
  }

  next() { this.#index += 1; this.#show(); this.#start(); }
  previous() { this.#index -= 1; this.#show(); this.#start(); }
  toggle() { this.#paused = !this.#paused; this.#syncToggle(); this.#start(); }

  #show() {
    const slides = this.refs.slides ?? [];
    if (!slides.length) return;
    this.#index = (this.#index + slides.length) % slides.length;
    slides.forEach((slide, index) => slide.setAttribute('aria-hidden', String(index !== this.#index)));
  }

  #syncToggle() {
    this.toggleAttribute('data-paused', this.#paused);
    const button = this.refs.toggle;
    if (button) button.setAttribute('aria-label', this.#paused ? button.dataset.playLabel : button.dataset.pauseLabel);
  }

  #stop() { clearTimeout(this.#timer); this.#timer = undefined; }

  #start() {
    this.#stop();
    if (this.#paused || document.hidden || this.matches(':hover, :focus-within')) return;
    const seconds = Math.max(5, Number(this.dataset.interval) || 6);
    this.#timer = setTimeout(() => this.next(), seconds * 1000);
  }
}

if (!customElements.get('orvena-benefits')) customElements.define('orvena-benefits', OrvenaBenefits);
